import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import logo from '../Images/logo.png';
import AccountModal from './AccountModal';
import { useAuth } from '../context/AuthContext';

function Header({ openAccount: controlledOpenAccount, onOpenAccount, onCloseAccount }) {
  const [internalOpenAccount, setInternalOpenAccount] = useState(false);
  const { isAuthenticated, isLoading, isPasswordRecovery } = useAuth();
  const openAccount = controlledOpenAccount ?? internalOpenAccount;
  const openModal = useCallback(() => {
    if (onOpenAccount) {
      onOpenAccount();
      return;
    }

    setInternalOpenAccount(true);
  }, [onOpenAccount]);

  const closeModal = useCallback(() => {
    if (onCloseAccount) {
      onCloseAccount();
      return;
    }

    setInternalOpenAccount(false);
  }, [onCloseAccount]);

  useEffect(() => {
    if (isPasswordRecovery) {
      openModal();
    }
  }, [isPasswordRecovery, openModal]);

  return (
    <header className="header">
      <Link to="/">
        <img className="logo" src={logo} alt="mantis" />
      </Link>

      <div className="header-actions">
        <button
          className="signup-btn"
          onClick={openModal}
          disabled={isLoading}
        >
          {isLoading
            ? 'Loading...'
            : isAuthenticated
              ? 'My Account'
              : 'Sign In'}
        </button>
      </div>

      <AccountModal open={openAccount} onClose={closeModal} />
    </header>
  );
}

export default Header;
